import { Route, Switch } from "react-router-dom";
import ListagemDocumentos from "./Listagem";

function DocumentosPages() {
  return (
    <Switch>
      <Route path="/cadastros/documentos" component={ListagemDocumentos} />
    </Switch>
  );
}

export default DocumentosPages;
